// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"breadcrumbs_breadcrumbs__d-tH5","crumbSpacer":"breadcrumbs_crumbSpacer__SL3ZN"};